import { render, staticRenderFns } from "./PonitExchange.vue?vue&type=template&id=7dccc4be&scoped=true&"
import script from "./PonitExchange.vue?vue&type=script&lang=js&"
export * from "./PonitExchange.vue?vue&type=script&lang=js&"
import style0 from "./PonitExchange.vue?vue&type=style&index=0&id=7dccc4be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dccc4be",
  null
  
)

export default component.exports